import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { ReactComponent } from "./world-map.svg";

export default class WorldMapSvg extends PureComponent {
	static propTypes = {
		mutateSvg: PropTypes.func.isRequired
	};

	componentDidMount() {
		this.props.mutateSvg(this.ref);
	}

	render() {
		return <ReactComponent ref={node => (this.ref = node)} />;
	}
}
